import React from "react";
import { Link } from "react-router-dom";
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import UsuariosTabla from './UsuariosTabla.jsx';

const UsuariosListar = () => {
    return (
      <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item"><Link to="/">Administración de usuarios</Link></li>
        <li className="breadcrumb-item active">Listado de usuarios</li>
      </ol>
      <h1 className="page-header">Administración de usuarios <small></small></h1>
      <Panel>
        <PanelHeader>Usuarios registrados</PanelHeader>
        <PanelBody>
            <UsuariosTabla/>
        </PanelBody>
      </Panel>
    </div>
    );
  };
  export default UsuariosListar;
